import { Button } from '../../../components/ui/legacy'
import { Icon } from '@iconify/react'
import { MODALS, useModal } from '../../../context/ModalProvider'

export default function BookPackageFooter() {
  const { handleOpenModal } = useModal()

  return (
    <>
      <div className="fixed bottom-8 right-8 z-10">
        <Button
          variant={'primary'}
          onClickHandler={() => {
            handleOpenModal(MODALS.ADD_BOOK_PACKAGE)
          }}
          className="flex items-center gap-2 rounded-md px-4 py-2 shadow-lg"
        >
          <Icon
            icon="ph:folder-simple-plus"
            width="1.5rem"
            className="text-white"
          />
          <span className="text-white">Thêm gói sách</span>
        </Button>
      </div>
    </>
  )
}
